const [ w, d ] = [ window, document ]

const detail_init = async () => {

  let the_id = d.body.classList.value.replace(/^.+is--article-([\d]+)(.+)?$/,'$1')  
  let content = 'galleries'

  // 全記事取得
  let articles = await $.getArticles({ content })
  let categories = await $.getCategories({ content })
  let the_article = articles.filter( a => (a.id == the_id) ).shift()
  the_article.category = categories.filter( c => c.id == the_article.category )[0]

  // 詳細ヘッダー
  let tags = keywords => {
    let html = ""
    if(!keywords || keywords.length == 0) return ''
    keywords.forEach( key => html += `<a href="/galleries/?mode=list&tag=${ encodeURI( key ) }">${key}</a>` )
    return `<div class="tags">${html}</div>`
  }
  let $head = $(`
    <div class="galleries-detail__head">
      ${the_article.category.name ? `<span class="cat">${the_article.category.name}</span>`: '' }
      <h3 class="title">${the_article.title}</h3>
      ${the_article.desc.length ? `<p class="desc">${the_article.desc}</p>`: '' }
      ${tags(the_article.keywords)}
    </div>
  `)
  $('.element_detail > .title, .detail_title').remove()
  $head.prependTo('.element_detail')
  
  // ページングボタン名
  let opt ={
        prev:'PREV',
        next:'NEXT',
        list:'一覧へ戻る'
      };
  let $pagination = $( '.paginationbox .pageNav>a[href]' )

  $pagination.each(function(){
    let id = this.href.match(/article=([\d]+)/)[1],
        item = articles.filter(function(o,i){
          if(o.id==id) return true;
        }).shift();
    let html = `
      <span>${item.title}</span>
      <figure class="thumb"><img src="${item.thumb}" width="120" /></figure>
    `
    if( this.classList.contains('prev') ) opt.prev = html
    if( this.classList.contains('next') ) opt.next = html
  });
  $.pagingText(opt)


}


export default function GALLERIES () {
  d.addEventListener('DOMContentLoaded', () => {
    if( d.querySelectorAll('.element_detail').length ) detail_init()
  })
}